'use client';
import { createContext } from 'react';
import { ContextOptions } from '@/contexts/BentoStreamContext/types';

export const BentoStreamContext = createContext<ContextOptions>(
  {} as ContextOptions
);

export { BentoStreamContextProvider } from '@/contexts/BentoStreamContext/Provider';
export { useBentoStreamContext } from '@/contexts/BentoStreamContext/hooks';
